import { setDefaultOptions } from 'date-fns'
import * as locales from 'date-fns/locale'
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import { FetchTranslationsResponse } from '@app/api'
import { getUserLanguage } from '@app/utils'

import { DEFAULT_LANG } from './constants'

export const init = (data: FetchTranslationsResponse): void => {
  const locale = getUserLanguage()

  if (!i18n.isInitialized) {
    i18n.use(initReactI18next).init({
      lng: locale,
      fallbackLng: DEFAULT_LANG,
      interpolation: {
        escapeValue: false,
      },
      keySeparator: '.',
      pluralSeparator: '.plural_',
    })
  }

  i18n.addResources(DEFAULT_LANG, 'translation', data[DEFAULT_LANG])
  data.locales.forEach((locale) => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    i18n.addResources(locale, 'translation', data[locale])
  })

  void i18n.changeLanguage(locale)

  setDefaultOptions({
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    locale: locales[locale],
  })
}
